import { render, staticRenderFns } from "./HorizontalScrollText.vue?vue&type=template&id=1381d9fa&scoped=true&"
import script from "./HorizontalScrollText.vue?vue&type=script&lang=ts&"
export * from "./HorizontalScrollText.vue?vue&type=script&lang=ts&"
import style0 from "./HorizontalScrollText.vue?vue&type=style&index=0&id=1381d9fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1381d9fa",
  null
  
)

export default component.exports